import { render } from "./profileGender.vue?vue&type=template&id=6e5ab555&scoped=true"
import script from "./profileGender.vue?vue&type=script&lang=js"
export * from "./profileGender.vue?vue&type=script&lang=js"

import "./profileGender.vue?vue&type=style&index=0&id=6e5ab555&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5ab555"]])

export default __exports__